var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.switchWidth") } },
    [
      _c("el-input-number", {
        staticStyle: { width: "100%" },
        model: {
          value: _vm.optionModel.switchWidth,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "switchWidth", $$v)
          },
          expression: "optionModel.switchWidth",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }